import { Component, Input } from '@angular/core';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from 'ionic-angular';
/**
 * Generated class for the CoFacebookComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-facebook',
  templateUrl: 'co-facebook.html',
  inputs: ['blockInfo']
})
export class CoFacebookComponent {
  libraryInfo: {name: string, fullLink: string, link: string, cleanLink: any} = {name: '', fullLink: '', link: '', cleanLink: null};
  loadPage: boolean = false;
  frameWidth: any;
  @Input('blockInfo') blockInfo: any;

  constructor(private clientDetails: ClientDetailsProvider, private sanitizer: DomSanitizer, public platform: Platform) {
    let self = this;
    this.clientDetails.load().then( (response) => {
      // console.log(response)
      self.setInfo(response);
    });
  }

  setInfo(res) {
    this.libraryInfo.name = res.name;
    try {
      let url = this.blockInfo.url.split('/');
      let width: number = null;
      if (Number(this.platform.width()) >= 580){
        width = Math.min(Number(this.platform.width())/2, 400);
      } else {
        width = Math.min(Number(this.platform.width()), 400);
      }

      this.frameWidth = width;

      this.libraryInfo.link = url[3]? url[3] : url[0];
      this.libraryInfo.fullLink = `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F${this.libraryInfo.link}%2F&tabs=timeline&width=${width}&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
      this.libraryInfo.cleanLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.libraryInfo.fullLink);
      // console.log(this.libraryInfo);
      this.loadPage = true;
    } catch (ex) {
      console.log('Error: ', ex);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-facebook/co-facebook.ts